import React from "react";

function EthereumScalability() {
  return (
    <>
      <div
        className="about-style-three-area default-padding bg-gray bg-cover"
        style={{
          background:
            "url(https://validthemes.net/site-template/robok/assets/img/shape/banner-16.jpg)",
        }}
      >
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <h4 className="sub-title">AI writing assistant</h4>
              <h2 className="title split-text-right split-text-in-right">
                Polygon zkEVM: The Future of Ethereum Scalability
              </h2>
              <p>
                Polygon zkEVM offers Ethereum-compatible scalability solutions
                through zero-knowledge rollups, optimizing transaction speed,
                cost, and efficiency. This layer-2 solution empowers projects to
                scale without compromising on security or decentralization.
              </p>

              <a className="btn btn-style-one" href="#">
                Know more
              </a>
            </div>
            <div className="col-lg-6">
              <div className="about-style-three-thumb">
                <img
                  className="fade-up-anim"
                  src="https://validthemes.net/site-template/robok/assets/img/illustration/dashboard-4.jpg"
                  alt="Image Not Found"
                />
                <img
                  className="fade-up-anim"
                  src="https://validthemes.net/site-template/robok/assets/img/illustration/1.gif"
                  alt="Image Not Found"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default EthereumScalability;
